export const inventoryCategory = item => item.categoryInfo || (item.category
  ? { key: item.category, name: item.category.charAt(0).toUpperCase() + item.category.slice(1), displayOrder: 10000 }
  : { key: "__uncategorized", name: "Uncategorized", displayOrder: Number.MAX_SAFE_INTEGER });

// Pack category rows, not individual cards: a heading always travels with its row.
export function planCategoryPages(items) {
  const groups = new Map();
  items.filter(item => item.isPublished !== false).forEach(item => {
    const category = inventoryCategory(item);
    if (!groups.has(category.key)) groups.set(category.key, { category, items: [] });
    groups.get(category.key).items.push(item);
  });
  const ordered = [...groups.values()].sort((a, b) => a.category.displayOrder - b.category.displayOrder || a.category.name.localeCompare(b.category.name, "en") || a.category.key.localeCompare(b.category.key, "en"));
  const rows = [];
  ordered.forEach(group => {
    group.items.sort((a, b) => Number(Boolean(b.isFeatured)) - Number(Boolean(a.isFeatured))
      || String(b.createdAt || "").localeCompare(String(a.createdAt || ""))
      || String(a.title || "").localeCompare(String(b.title || ""), "en")
      || String(a.slug || a._id || "").localeCompare(String(b.slug || b._id || ""), "en"));
    for (let start = 0; start < group.items.length; start += 2) rows.push({ category: group.category, items: group.items.slice(start, start + 2) });
  });
  const pages = [];
  for (let start = 0; start < rows.length; start += 2) pages.push(rows.slice(start, start + 2));
  return pages;
}
